export default "__VITE_ASSET__CTiZtUIW__"